<template>
  <div class="charge-view">
    <!-- 视听卡名称 -->
    <div class="charge-view-header">
      <div
        class="header-logo"
        :class="CardMap[product.productName]"
      />
      <div class="header-name">{{ product.productName }}</div>
    </div>

    <!-- 充值方式 -->
    <div class="charge-view-style">
      <div class="style-title">
        请选择充值方式
      </div>
      <div class="style-list">
        <template>
          <div
            v-for="item in styleList"
            :key="item.skuValueCode"
            class="style-item"
            :class="{active: rechargeStyle === item.skuValueCode}"
            @click="rechargeChange(item.skuValueCode)"
          >
            <div
              class="style-list-item"
              :class="{active: rechargeStyle === item.skuValueCode}"
            >
              {{ item.skuValueName }}
            </div>
          </div>
        </template>

      </div>

      <div class="style-desc">
        说明: {{ chargeDesc[rechargeStyle] }}
      </div>
    </div>

    <!-- 充值类型 -->
    <div class="charge-view-class">
      <div class="class-title">
        请选择充值类型
      </div>

      <div class="class-list">
        <template v-for="item in typeList">
          <div
            class="class-item"
            v-if="!item.disabled"
            :class="{active: skuValue === item.skuValueCode}"
            @click="skuValueChange(item)"
            :key="item.skuValueCode"
          >
            <div class="class-name">{{ item.skuValueName }}</div>
            <template v-if="rightRulePackageBindId">
              <div class="class-price">{{ item.productSkuBasePriceToYuan }}元</div>
            </template>
            <template v-else>
              <div class="class-price">{{ item.providerPriceToYuan }}元</div>
              <div
                class="class-origin-price"
              >
                原价{{ item.productSkuBasePriceToYuan }}元
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>

    <!-- 充值账号 -->
    <div
      class="charge-view-account"
      v-if="rechargeStyle==='SV30003101'"
    >
      <div class="account-field">
        填写充值账号
      </div>

      <input
        type="text"
        v-model="chargeAccount"
        class="account-input"
        placeholder="请输入视听卡充值账号"
        maxlength="30"
      >
    </div>

    <!-- 充值数量 -->
    <template v-if="rechargeStyle !== 'SV30003101'">
      <div class="charge-view-amount">
        <div class="amount-field">
          请选择电子卡数量
        </div>

        <div class="amount-btn">
          <div
            class="minus"
            @click="minus"
          >-</div>
          <input
            type="text"
            class="input"
            v-model="inputAmount"
            @input="inputHandle"
            @blur="blurHandle"
            :disabled="maxNum <= 0"
          >
          <div
            class="add"
            @click="add"
          >+</div>
        </div>
      </div>
      <div
        class="charge-view-tips"
        v-if="tipsShow"
      >
        <span v-if="maxNum > 0">最大只支持{{ maxNum }}</span>
        <span v-else>请先选择充值类型</span>
      </div>
    </template>

    <!-- 权益 -->
    <div class="charge-view-right">
      <right-selector
        ref="rightSelectorRef"
        v-model="selectedRight"
        :right-options="rightList"
        :rule-product-sku-code="curSkuItem.productSkuCode"
        service-name="充值类型"
        :right-discount="discountPrice"
        :show-right-name="!!rightRulePackageBindId"
      />
    </div>

    <!-- 立即充值 -->
    <div
      class="charge-view-btn"
      :class="{disabled: btnDisabled}"
      @click="preClick"
    >
      <span
        style="font-weight: 500"
        v-if="!rightRulePackageBindId"
      >¥ {{ payPrice || '0.00' }} </span>
      立即充值
    </div>

    <!-- 说明 -->
    <template v-if="product.productDesc">
      <div class="charge-view-desc">
        <div class="line" />
        <div class="text">说明</div>
        <div class="line" />
      </div>

      <div class="charge-view-desctext">
        {{
          product.productDesc
        }}
      </div>
    </template>

    <confirm-mobile-or-email
      ref="confirmMobile"
      @getResult="getResult"
      :type="chargeType"
    />
    <confirm-account
      ref="confirmAccount"
      :confirm-val="chargeAccount"
      @getResult="getResult"
    />
  </div>
</template>

<script>
import RightSelector from '@/components/right-selector-new.vue';
import ConfirmMobileOrEmail from '@/components/confirmMobileOrEmail.vue';
import ConfirmAccount from '@/components/confirmAccount';
import {
  carLifeOrderDetail,
  carLifeOrderCreate,
  carLifePayPre,
  findValidRight,
  getAllSimpleProductInfo,
  getSpecsListByProductCode,
  getThirdCardInfo
} from '@/common/api';
import { cloneDeep } from 'lodash';
import { Toast } from 'vant';
import { cookieGet, cookieSet } from '@/common/cookie';
import { CarLifeOrderStatus, CardMap } from '@/common/constant';
import Pay from '@/common/weixin';
import { evaluate } from 'mathjs/lib/cjs/index.js';
import { doExchange } from '@/common/clipboard.js';

const chargeDesc = {
  'SV30003101': '选择直充商品后请填写充值账号。',
  'SV30003102': '支付成功后，在订单详情页查看卡密，请妥善保管，以便提取卡密商品使用。',
  'SV30003103': '支付成功后，券码会发送到短信附带链接进行兑换。'
};
const chargeStyleMap = {
  'SV30003101': 1,
  'SV30003102': 2,
  'SV30003103': 3
};
const chargeStyleNameMap = {
  1: '账号直充',
  2: '卡密兑换',
  3: '券码兑换'
};
export default {
  name: 'ChargeView',
  data() {
    return {
      CardMap,
      chargeDesc,
      productCode: '',
      contactPhone: '',
      chargeAccount: '',
      inputAmount: 1,
      amount: 1,
      rechargeStyle: 1,
      skuValue: undefined, // 选中充值类型
      chargeType: 1,
      product: {},
      selectedRight: {},
      styleList: [],
      typeList: [],
      originalRightList: [],
      rightList: [],
      tipsShow: false,
      maxNum: 0,
      curDenomination: 0,
      orderNo: '', // 用于保存下单后获取到的订单号
      checkList: [],
      productSkuCode: '',
      rightRulePackageBindId: '',
      source: ''
    };
  },
  components: {
    RightSelector,
    ConfirmMobileOrEmail,
    ConfirmAccount
  },
  computed: {
    curSkuItem() {
      if (!this.product || !this.product.productStandardSkuRespVoList) {
        return {};
      }
      const skuCode = `${this.rechargeStyle}|${this.skuValue}`;
      console.log('skuCode', skuCode);
      return this.product.productStandardSkuRespVoList.find(item => {
        return item.skuValueCode === skuCode;
      }) || {};
    },
    curStyle() {
      if (!this.typeList.length) {
        return {};
      }
      return this.typeList.find(type => {
        return type.skuValueCode === this.skuValue;
      }) || {};
    },
    payPrice() {
      const discount = this.discountPrice;
      const denomination = Number(this.curStyle.providerPriceToYuan) || 0;
      return Math.max(0, evaluate(`${this.amount} * ${denomination} - ${discount}`).toFixed(2));
    },
    btnDisabled() {
      return this.maxNum <= 0 || (this.rechargeStyle === 'SV30003101' && this.chargeAccount === '');
    },
    discountPrice() {
      console.log('this.discountPrice', this.selectedRight);
      if (this.selectedRight && this.selectedRight.rightDiscountType === 2) {
        return Number(this.curSkuItem.providerPriceToYuan) || 0;
      }

      return this.selectedRight.rightDiscount || 0;
    },
    isXDCX() {
      if (this.$route.query.companyNo === 'XDCX' && this.$route.query.erId) {
        return true;
      } else {
        return false;
      }
    }
  },
  filters: {
    yuan(val) {
      if (!val) {
        return '0.00';
      }
      return val.toFixed(2);
    }
  },
  watch: {},
  methods: {
    async getDetail() {
      try {
        const res = await getAllSimpleProductInfo({
          productCode: this.productCode
        });
        this.product = res || {};
        return true;
      } catch (error) {
        return false;
      }
    },
    async getSkuList() {
      try {
        const res = await getSpecsListByProductCode({
          productCode: this.productCode
        });
        const style = 'SP30000301';
        const type = 'SP30000302';
        res.forEach(item => {
          if (item.skuAttributeCode === style) {
            // 对psvList进行排序，将"账号直充"排在最前面
            item.psvList.sort((a, b) => {
              if (a.skuValueName === '账号直充') return -1;
              if (b.skuValueName === '账号直充') return 1;
              return 0;
            });
            this.styleList = item.psvList;
          // if (this.styleList.length) {
          //   this.rechargeStyle = this.styleList[0].skuValueCode;
          // }
          }
          if (item.skuAttributeCode === type) {
            item.psvList.forEach(item => {
              item.disabled = true;
              item.productSkuBasePriceToYuan = '0.00';
              item.providerPriceToYuan = '0.00';
            });
            this.typeList = item.psvList;
          }
        });

        // this.searchSkuProduct();
        return true;
      } catch (error) {
        return false;
      }
    },
    resetRight() {
      this.selectedRight = {};
      this.rightList = cloneDeep(this.originalRightList);
    },
    async getRightList() {
      try {
        if (!this.productCode) {
          return;
        }
        this.$toast.loading({
          message: '正在处理权益...',
          forbidClick: true,
          duration: 0
        });
        const res = await findValidRight({
          phone: this.contactPhone,
          productCode: this.productCode,
          rightPackageCode: this.$route.query.erId
        });
        this.$toast.clear();
        if (!res) {
          return;
        }
        this.originalRightList = res;
        this.originalRightList.forEach((item) => {
          item.rightId = item.rightPackageCode + '-' + item.rightCode;
          item.timesLeft = item.validCount;
          item.disabled = true; // 都是禁用的
        });
        this.rightList = cloneDeep(this.originalRightList);

        if (this.isXDCX) {
          this.changeDiscount();
        }
        // 选中后自动筛选权益
        // if (this.skuValue) {
        //   this.skuCodeGetRight();
        // }
        return true;
      } catch (error) {
        console.log('error', error);
        return false;
      }
    },
    changeDiscount() {
      this.rightList && this.rightList.forEach(item => {
        if (this.$route.query.erId == item.rightPackageCode) {
          this.selectedRight = item;
          this.selectedRight.disabled = false;
        } else if (this.$route.query.rightRulePackageBindId == item.rightRulePackageBindId) {
          this.selectedRight = item;
          this.selectedRight.disabled = false;
        }
        item.rightRuleList && item.rightRuleList.forEach(items => {
          this.$set(items, 'skuValueCodeList', items.skuValueCode.split('|'));
          this.checkList.push(items);
          console.log(this.checkList);
        });
      });
      const arr = [];
      this.styleList.forEach(i => {
        arr.push(i.skuValueCode);
      });
      const arr2 = [];
      this.typeList.forEach(i => {
        arr2.push(i.skuValueCode);
      });
      const arrs = [arr, arr2];
      const arrList = doExchange(arrs);
      this.checkList && this.checkList.forEach(item => {
        arrList && arrList.forEach(items => {
          if (item.skuValueCode == items) {
            this.rechargeStyle = item.skuValueCodeList[0];
            this.skuValue = item.skuValueCodeList[1];
            if (item.rightType == '2') {
              this.selectedRight.rightDiscountType = 2;
            }
          }
        });
      });
      this.searchSkuProduct();
      if (this.rechargeStyle === 'SV30003101') {
        this.inputAmount = 1;
        this.amount = 1;
        this.maxNum = 1;
      } else {
        // 获取具体规格后的产品
        this.getCardStore(this.curSkuItem.productSkuCode);
      }
    },
    // 根据sku筛选权益
    skuCodeGetRight() {
      const productSkuCode = this.curSkuItem.productSkuCode;
      const rightList = cloneDeep(this.originalRightList);
      if (!productSkuCode) {
        this.rightList = rightList;
        return;
      }

      this.rightList = rightList
        .map((item) => {
          const rightRuleList = item.rightRuleList || [];
          const isMatched = rightRuleList.some(
            ({ skuCode }) => productSkuCode === skuCode
          );
          return {
            ...item,
            disabled: !isMatched
          };
        })
        .sort((a) => (a.disabled ? 1 : -1)); // 排序，有效的放前面

      console.log('this.selectedRight', this.selectedRight);
    },
    rechargeChange(code) {
      if (this.isXDCX) {
        return;
      }
      this.rechargeStyle = code;
      this.maxNum = 0;
      this.skuValue = undefined;
      this.inputAmount = 1;
      this.amount = 1;
      this.searchSkuProduct();

      // 切换确认弹窗的文案
      this.chargeType = chargeStyleMap[this.rechargeStyle] === 2 ? 1 : 2;
    },
    skuValueChange(item) {
      // if(this.isXDCX){
      //   return
      // }
      if (this.skuValue === item.skuValueCode) {
        return;
      }
      this.skuValue = item.skuValueCode;
      this.selectedRight = {};
      // 直充
      if (this.rechargeStyle === 'SV30003101') {
        this.inputAmount = 1;
        this.amount = 1;
        this.maxNum = 1;
      } else {
        // 获取具体规格后的产品
        this.getCardStore(this.curSkuItem.productSkuCode);
      }
      if (this.isXDCX) {
        this.changeDiscount();
      }
      this.skuCodeGetRight();
      // 切换项目选择的时候，若当前选中项目有可用权益则默认选中第一个权益
      this.selectDefaultRight();
    },
    searchSkuProduct() {
      this.typeList.forEach(item => {
        item.disabled = true;
        item.productSkuBasePriceToYuan = '0.00';
        item.providerPriceToYuan = '0.00';
      });
      this.product.productStandardSkuRespVoList.forEach(sku => {
        const skuArr = sku.skuValueCode.split('|');
        if (skuArr[0] === this.rechargeStyle) {
          this.typeList.forEach(item => {
            if (item.skuValueCode === skuArr[1]) {
              item.disabled = false;
              item.productSkuBasePriceToYuan = sku.productSkuBasePriceToYuan;
              item.providerPriceToYuan = sku.providerPriceToYuan;
            }
          });
        }
      });

      const productSkuCode = this.$route.query.productSkuCode;
      if (productSkuCode) {
        const item = this.product.productStandardSkuRespVoList.find(item => item.productSkuCode === productSkuCode);
        console.log('item', item);
        if (item) {
          const arr = item.skuValueCode.split('|');
          const item2 = this.typeList.find(item => item.skuValueCode === arr[1]);
          this.skuValueChange(item2);
          console.log('this.skuValue', this.skuValue);
        }
      }
    },
    // 获取卡库存信息
    async getCardStore(skuCode) {
      if (!skuCode) {
        return;
      }
      const res = await getThirdCardInfo({
        productCode: this.productCode,
        productSkuCode: skuCode
      });
      if (res) {
        const maxNum = res.innum || 0;
        // 最大购买数量为200
        this.maxNum = Math.min(maxNum, 200);
        if (maxNum <= 0) {
          this.$toast('该面值类型库存不足');
        }
      }
    },
    validate() {
      if (!this.skuValue) {
        this.$toast('未选择充值面值');
        return false;
      }
      if (!this.maxNum) {
        this.$toast('当前面值库存不足');
        return false;
      }
      return true;
    },
    preClick() {
      if (this.$route.query.companyNo === 'XDCX' && this.rightList.length <= 0) {
        return;
      }
      if (this.$route.query.companyNo === 'XDCX' && this.payPrice > 0.00) {
        this.$toast('没有可用卡券');
        return;
      }
      if (!this.validate()) {
        return;
      }
      if (this.rechargeStyle === 'SV30003101') {
        if (this.chargeAccount === '') {
          return;
        }
        this.$refs.confirmAccount.openDialog();
      } else {
        this.$refs.confirmMobile.openDialog();
      }
      // 确认弹窗回调代码见 getResult
    },
    add() {
      if (this.maxNum <= 0) {
        return;
      }
      if (this.amount + 1 <= this.maxNum) {
        this.inputAmount++;
        this.amount = this.inputAmount;
      } else {
        Toast(`最大数量为${this.maxNum}`);
      }
    },
    minus() {
      if (this.maxNum <= 0) {
        return;
      }
      if (this.amount - 1 >= 1) {
        this.inputAmount--;
        this.amount = this.inputAmount;
      }
    },
    inputHandle() {
      this.inputAmount = this.inputAmount.replace(
        /^\D*([0-9]\d*\.?\d{0,2})?.*$/g,
        '$1'
      );
    },
    blurHandle() {
      if (this.inputAmount > this.maxNum) {
        this.inputAmount = this.maxNum;
        this.amount = this.maxNum;
        this.tipsShow = true;
      } else if (this.inputAmount < 1) {
        this.inputAmount = 1;
        this.amount = 1;
      } else {
        this.amount = this.inputAmount;
        this.tipsShow = false;
      }
    },
    isEmptyObject(obj) {
      return Object.keys(obj).length <= 0;
    },
    // ---------- 下单流程 start -------------
    async createOrder() {
      const chargeWay = chargeStyleMap[this.rechargeStyle];
      const rechargeTypeName = this.curStyle.skuValueName + this.curStyle.productSkuBasePriceToYuan + '元';
      const params = {
        productSkuCode: this.curSkuItem.productSkuCode,
        cardQuantity: this.amount,
        contactPhone: this.contactPhone,
        rechargeWay: chargeWay,
        rechargeWayName: chargeStyleNameMap[chargeWay],
        rechargeAccount: this.chargeAccount,
        rechargeTypeName
      };
      if (!this.isEmptyObject(this.selectedRight)) {
        params.rightPackageCode = this.selectedRight.rightPackageCode;
        params.rightRuleCode = this.getRightRuleCode();
        params.version = this.selectedRight.version;
      }
      return await carLifeOrderCreate(params);
    },

    async pay() {
      const envMap = ['1', '1', '4'];
      // 调起预支付接口成功后
      const prepayRs = await carLifePayPre({
        payType: envMap[this.$browserEnv], // 支付环境
        orderNo: this.orderNo,
        source: this.$route.query.source
      });
      this.prePayHandle(prepayRs);
    },

    prePayHandle(payload) {
      const _payload = {
        appId: payload.appId,
        timeStamp: payload.timeStamp,
        nonceStr: payload.nonceStr,
        package: payload.packageValue,
        signType: payload.signType,
        paySign: payload.paySign,
        prepayId: payload.prepayId,
        mwebUrl: payload.mwebUrl
      };
      switch (this.$browserEnv) {
        case 0:
          Pay.mpPay(_payload, this.orderNo);
          break;
        case 1:
          Pay.wxPay(_payload, this.prePaySuccess, this.prePayFail);
          break;
        case 2:
          Pay.browserPay(_payload.mwebUrl, this.orderNo);
          break;
      }
    },

    getRightRuleCode() {
      const right = this.selectedRight;
      for (let i = 0; i < right.rightRuleList.length; i++) {
        const rule = right.rightRuleList[i];
        if (rule.skuCode === this.curSkuItem.productSkuCode) {
          return rule.rightRuleCode;
        }
      }
    },

    async showConfirmDialog() {
      this.$toast.loading({
        message: '支付结果检查中...',
        forbidClick: true,
        duration: 0
      });
      this.checkPay();
    },

    async checkPay() {
      try {
        const res = await carLifeOrderDetail({
          orderNo: this.orderNo
        });
        this.$toast.clear();
        // 待支付的，去订单详情
        if (res.rechargeStatus == CarLifeOrderStatus.unpaid) {
          this.prePayFail();
        } else {
          this.prePaySuccess();
        }
      } catch (error) {
        this.$toast.clear();
      }
    },

    prePayFail() {
      this.$router.replace({
        path: '/mediaOrderDetail',
        query: {
          orderNo: this.orderNo
        }
      });
    },

    prePaySuccess() {
      this.$router.replace({
        name: 'resultPage',
        query: {
          orderNo: this.orderNo,
          orderStatus: CarLifeOrderStatus.success,
          orderType: '03'
        }
      });
    },

    async chargeHandle() {
      this.$toast.loading({
        message: '提交中',
        forbidClick: true,
        duration: 0
      });
      const res = await this.createOrder();
      this.orderNo = res.orderNo;
      if (res.needPay) {
        await this.pay();
      } else {
        this.prePaySuccess();
      }
      this.$toast.clear();
    },
    // 获取用户确认的手机号
    getResult(result) {
      this.chargeAccount = result;
      this.chargeHandle();
    },
    selectDefaultRight(right) {
      console.log('selectDefaultRight', right);
      if (!right) {
        const rightListFilter = this.rightList.filter(right => !right.disabled);
        console.log(this.rightList, 'this.rightList');
        console.log(rightListFilter, 'rightListFilter');

        if (rightListFilter.length > 0) {
          right = rightListFilter[0];
        }
      }
      if (right) {
        this.selectedRight = right;
        this.$nextTick(() => {
          this.$refs.rightSelectorRef?.handleSelect(right);
        });
      }
    },
    selectDefaultType() {
      // 处理选中充值方式
      const findSsku = this.product.productStandardSkuRespVoList.find(sku => sku.productSkuCode === this.$route.query.productSkuCode);
      console.log('findSsku', findSsku);
      if (findSsku) {
        const skuArr = findSsku.skuValueCode.split('|');
        this.rechargeChange(skuArr[0]);
      }
      this.skuCodeGetRight();
      this.rightList && this.rightList.forEach(right => {
        if (this.rightRulePackageBindId == right.rightRulePackageBindId) {
          // 处理充值方式、充值类型、默认权益
          // const checkList = [];
          // right.rightRuleList && right.rightRuleList.forEach(items => {
          //   this.$set(items, 'skuValueCodeList', items.skuValueCode.split('|'));
          //   checkList.push(items);
          // });
          // const arr = [];
          // this.styleList.forEach(i => {
          //   arr.push(i.skuValueCode);
          // });
          // const arr2 = [];
          // this.typeList.forEach(i => {
          //   arr2.push(i.skuValueCode);
          // });
          // const arrs = [arr, arr2];
          // const arrList = doExchange(arrs);
          // checkList && checkList.forEach(item => {
          //   arrList && arrList.forEach(items => {
          //     if (item.skuValueCode == items) {
          //       // 默认选中充值方式
          //       this.rechargeChange(item.skuValueCodeList[0]);
          //       if (item.rightType == '2') {
          //         right.rightDiscountType = 2;
          //       }
          //     }
          //   });
          // });

          if (findSsku) {
            right.rightRuleList && right.rightRuleList.forEach(item => {
              if (findSsku.skuValueCode === item.skuValueCode) {
                if (item.rightType == '2') {
                  right.rightDiscountType = 2;
                }
              }
            });
          }
          this.selectDefaultRight(right);
        }
      });
    },
    defaultHandle() {
      if (this.styleList.length) {
        this.rechargeChange(this.styleList[0].skuValueCode);
      }
    }
    // ---------- 下单流程 end ---------------

  },
  async created() {
    if (this.$route.query.code) {
      this.productCode = this.$route.query.code;
      cookieSet('mediaCardCode', this.productCode);
    } else {
      this.productCode = cookieGet('mediaCardCode');
    }
    if (this.$route.query.productCode) {
      this.productCode = this.$route.query.productCode;
      cookieSet('mediaCardCode', this.productCode);
    }
    this.contactPhone = cookieGet('phone');
    if (this.$route.query.phone) {
      this.contactPhone = this.$route.query.phone;
    }
    if (this.$route.query.isCallBack) {
      this.orderNo = this.$route.query.orderNo;
      this.showConfirmDialog();
    }
    if (this.$route.query.rightRulePackageBindId) {
      this.rightRulePackageBindId = this.$route.query.rightRulePackageBindId;
    }
    if (this.$route.query.source) {
      this.source = this.$route.query.source;
    }
    // await this.getDetail();
    // this.getSkuList();
    // this.getRightList();
    // 三个接口全部返回后才做操作
    const resArr = await Promise.all([this.getDetail(), this.getSkuList(), this.getRightList()]);
    console.log('resArr: ', resArr);

    const isSuccess = resArr.every(res => !!res);
    if (isSuccess) {
      if (this.rightRulePackageBindId) {
        // 处理默认选中
        this.selectDefaultType();
      } else {
        this.defaultHandle();
      }
    } else {
      this.$toast('网络异常,请返回重试！');
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/card-icon.scss";
.charge-view {
  overflow: hidden;

  background: #F4F6F7;

  &-header {
    display: flex;
    align-items: center;

    height: 1.2rem;

    border-bottom: 1px solid #E6E6E6;
    background-color: #ffffff;

    line-height: 1.2rem;

    > .header-logo {
      flex: 0 0 0.72rem;

      width: 0.72rem;
      height: 0.72rem;
      margin-left: 0.4rem;

      background-size: 0.72rem 0.72rem;
    }

    > .header-name {
      margin-left: 0.16rem;

      white-space: nowrap;

      font-size: 0.4rem;
      font-weight: 500;
    }
  }

  &-style {
    padding: .32rem .4rem .24rem .4rem;

    background-color: #ffffff;

    > .style-title {
      margin-bottom: .24rem;

      font-size: .32rem;
    }

    .style-list {
      display: flex;

      .style-item{
        position: relative;

        margin-right: .2rem;

        filter: drop-shadow(0 0 1px  #E6E6E6) drop-shadow(0 0 1px  #E6E6E6) drop-shadow(0 0 1px  #E6E6E6);
        &.active {
          filter: drop-shadow(0 0 1px #3399FF) drop-shadow(0 0 1px #3399FF) drop-shadow(0 0 1px #3399FF);

          &::after {
            position: absolute;
            bottom: -.1rem;
            left: 50%;

            width: 0;
            height: 0;

            content: "";
            transform: translateX(-50%);

            border-width: .2rem .2rem 0 .2rem;
            border-style: solid;
            border-color: #CCE6FF transparent transparent transparent;
          }
        }
      }

      &-item {
        width: 2.1rem;
        height: .8rem;

        text-align: center;

        border-radius: .16rem;
        background: #FFFFFF;

        font-size: .32rem;
        line-height: .8rem;

        &.active {
          color: #3399FF;
          background-color: #CCE6FF;
        }
      }
    }

    > .style-desc {
      margin-top: .26rem;
      padding: .12rem .1rem;

      color: #999999;
      border-radius: .04rem;
      background-color: #FBF4F0;

      font-size: .24rem;
      line-height: .36rem;
    }
  }

  &-class {
    padding: .32rem .4rem .24rem .4rem;

    background-color: #ffffff;

    > .class-title {
      margin-bottom: .24rem;

      font-size: .32rem;
    }

    > .class-list {
      display: flex;
      flex-wrap: wrap;

      > .class-item {
        display: flex;
        flex-direction: column;

        box-sizing: border-box;
        width: calc((100% - .4rem) / 3);
        height: 1.8rem;
        margin-right: .2rem;
        margin-bottom: .2rem;
        padding: .16rem 0;

        text-align: center;

        border: 1px solid #E6E6E6;
        border-radius: .16rem;

        > .class-name {
          color: #383838;

          font-size: .36rem;
          font-weight: bold;
          line-height: .5rem;
        }

        > .class-price {
          margin-top: .04rem;

          color: #383838;

          font-size: .42rem;
          font-weight: bold;
          line-height: .59rem;
        }

        > .class-origin-price {
          margin-top: .04rem;

          color: #C8C8C8;

          font-size: .24rem;
          line-height: .33rem;
        }

        &:nth-child(3n) {
          margin-right: 0;
        }

        &.active {
          color: #3399FF;
          border-color: #3399FF;
          background-color: #CCE6FF;
        }

        &.disabled {
          opacity: 0.4;
          color: #383838;
          background: #FFFFFF;

          filter: drop-shadow(0 0 1px #E6E6E6);
        }
      }
    }
  }

  &-account {
    padding: .2rem .4rem .32rem .4rem;

    background-color: #ffffff;

    > .account-field {
      margin-bottom: .24rem;

      font-size: .32rem;
    }

    > .account-input {
      box-sizing: border-box;
      width: 100%;
      height: .96rem;
      padding-left: .4rem;

      border: .02px solid #CCCCCC;
      border-radius: .16rem;
      background: #FFFFFF;

      font-size: .32rem;
    }
  }

  &-amount {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: .2rem .4rem;

    background-color: #ffffff;

    font-size: .32rem;

    > .amount-field {

    }

    > .amount-btn {
      display: flex;

      > .minus {
        width: .64rem;
        height: .64rem;

        text-align: center;

        border: .02rem solid #D8DCE6;
        border-radius: .08rem 0 0 .08rem;
        background: #F5F7FA;

        line-height: .64rem;
      }

      > .input {
        width: 1.28rem;

        text-align: center;

        border: .02rem solid #DCDFE6;
        border-right: none;
        border-left: none;
      }

      > .add {
        width: .64rem;
        height: .64rem;

        text-align: center;

        border: .02rem solid #D8DCE6;
        border-radius: 0 .08rem .08rem 0;
        background: #F5F7FA;

        line-height: .64rem;
      }
    }
  }

  &-tips {
    padding: .2rem .4rem;

    text-align: right;

    color: #EA3F26;
    background-color: #ffffff;

    font-size: .24rem;

  }

  &-right {

  }

  &-btn {
    width: 6.7rem;
    height: .96rem;
    margin-top: .72rem;
    margin-bottom: .36rem;
    margin-left: .4rem;

    text-align: center;

    color: #FFF;
    border-radius: .16rem;
    background: #3399FF;

    font-size: .36rem;
    line-height: .96rem;

    &.disabled {
      background: #B3D9FF;
    }
  }

  &-desc {
    display: flex;
    align-items: center;

    margin: 0 .4rem;
    margin-top: .96rem;

    white-space: nowrap;

    > .line {
      width: 2.69rem;
      height: .02rem;

      background-color: #C8C8C8;
    }

    .text {
      margin: 0 .34rem;

      color: #383838;

      font-size: .32rem;
    }
  }

  &-desctext {
    margin: .4rem;

    white-space: pre-line;
    word-break: break-all;

    color: #787878;

    font-size: .24rem;
    line-height: .28rem;
  }
}
</style>
